
import { defineComponent } from "vue";
import { useRoute } from "vue-router";
import Countdown from "@/components/Countdown.vue";
import EventDates from "@/components/EventDates.vue";
import { Campaign } from "@/store/state";
import { register } from 'swiper/element/bundle';
register();

export default defineComponent({
  name: "event-list",
  data() {
    return {
      assetVer: 2023,
    };
  },
  components: {
    Countdown,
    EventDates,
  },
  props: {
    data: {
      type: Array as () => Campaign[],
      required: true,
    },
    categories: {
      type: Array,
      required: true,
    },
    sections: {
      type: Array,
      required: true,
    },
    versions: {
      type: Array,
      required: true,
    },
    versionNum: {
      type: String,
      required: true,
    },
    noPadding: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const route = useRoute();
    const availableVersions = ["jp", "gl"];
    const spaceBetween = 10;
    const onProgress = (e) => {
      const [swiper, progress] = e.detail;
      // console.log(progress)
    };
    const onSlideChange = (e) => {
      // console.log('slide changed')
    }

    const now = new Date();
    const currentTime = now.getTime()

    const filterResults = (table: Campaign[]) => {
      return props.categories.length < 1
        ? table
        : table
          .filter(
            (d) =>
              (!route.params.version ||
                route.params.version.toString().toLowerCase() ===
                availableVersions[d.version]) &&
              // props.versions.includes(d.version + 1) &&
              props.categories.includes(d.category.toLowerCase())
          )
          .filter((d) => {
            return (
              props.sections.length > 1 ||
              (props.sections.includes(1) &&
                new Date(d.in_date.replace(/\s/g, "T")) < now) ||
              (props.sections.includes(2) &&
                new Date(d.in_date.replace(/\s/g, "T")) > now)
            );
          });
    };

    const display = (d: Campaign) => {
      return (
        (!route.params.version ||
          route.params.version.toString().toLowerCase() ===
          availableVersions[d.version]) &&
        // props.versions.includes(d.version + 1) &&
        props.categories.includes(d.category) &&
        (props.sections.length > 1 ||
          (props.sections.includes(1) &&
            new Date(d.in_date.replace(/\s/g, "T")) < now) ||
          (props.sections.includes(2) &&
            new Date(d.in_date.replace(/\s/g, "T")) > now))
      );
    };

    return {
      filterResults,
      display,
      spaceBetween,
      onProgress,
      onSlideChange,
      currentTime,
    };
  },
});
